import { put, select, takeLatest } from 'redux-saga/effects';
import { getProject } from '../utils/zoomServices';
import { EnvUtils } from '../utils/EnvUtils';
import { Map, fromJS } from 'immutable';
import * as Selectors from '../reducers/selectors';
export const LOAD_REVIEW_PROJECT = 'LOAD_REVIEW_PROJECT';
export const SET_REVIEW_PROJECT = 'SET_REVIEW_PROJECT';
export const NEXT_REVIEW_SPREAD = 'NEXT_REVIEW_SPREAD';
export const PREVIOUS_REVIEW_SPREAD = 'PREVIOUS_REVIEW_SPREAD';

/**
 * Retucers
 */
let initialState = new Map({
  isLoaded: false,
});
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_REVIEW_PROJECT:
      let newState = fromJS(state)
        .set('pages', fromJS(action.project.pages))
        .set('pageItems', fromJS(action.project.pageItems))
        .set('section', action.project.currentSection)
        .set('isLoaded', true);
      return newState;
      break;
    default:
      return state;
  }
};

/**
 * actions
 */

export function loadReviewProject(projectPK) {
  return {
    type: LOAD_REVIEW_PROJECT,
    projectPK,
  };
}

export function nextReviewSpread() {
  return {
    type: NEXT_REVIEW_SPREAD,
  };
}

export function previousReviewSpread() {
  return {
    type: PREVIOUS_REVIEW_SPREAD,
  };
}

export function setReviewProject(project) {
  return {
    type: SET_REVIEW_PROJECT,
    project,
  };
}

/**
 * Sagas
 */

function* reviewProjectHandler(action) {
  try {
    let project = null;
    let spread;
    try {
      spread = 'first';
      let include = 'header,sections,imagesWithUsage,productInfo,warnings';
      let projectPK = { projectPK: action.projectPK };
      project = yield getProject(projectPK, include, null, null, spread);
    } catch (error) {
      console.error('error loading project', error);
    }
    yield put(setReviewProject(project));
  } catch (error) {
    console.error('error loading project', error);
  }
}

function* reviewProjectNavigationHandler(action) {
  let sections = yield select(Selectors.projectSectionsSelector);
  let currentSection = (yield select(Selectors.reviewSectionSelector)).toJS();
  let projectMetadata = yield select(Selectors.projectMetadataSelector);
  let currentProject = yield select(Selectors.reviewProjectSelector);
  let leftPage = currentProject.get('pages').first();
  let rightPage = currentProject.get('pages').last();

  let currentSpreadIndex = 0;
  let currentSectionIndex = 0;
  let sectionCounter = 0;

  let nextSpread;
  let spreadToLoad;
  let destinationSectionID = '';

  sections.map((section) => {
    if (currentSection.sectionID === section.get('sectionID')) {
      section.get('spreads').map((spread, spreadIndex) => {
        const isCurrent = spread
          .get('pages')
          .toJS()
          .some((page) => {
            return (
              leftPage.get('id') === page.pageID ||
              rightPage.get('id') === page.pageID
            );
          });

        if (isCurrent) {
          //unfortunately, we can't use the currentSection here, as we need it's index.
          currentSpreadIndex = spreadIndex;
          currentSectionIndex = sectionCounter;
        }
      });
    }
    ++sectionCounter;
  });
  let showFrontEndleafMagicNumber = EnvUtils.isTrue(
    process.env.showFrontEndleaf,
  )
    ? 0
    : 1;
  if (action.type == NEXT_REVIEW_SPREAD) {
    if (currentSpreadIndex + 1 >= currentSection.spreads.length) {
      let nextSectionIndex = currentSectionIndex + 1;
      if (sections.count() > nextSectionIndex) {
        let nextSection = sections.toList().toArray()[nextSectionIndex];
        // here the magic number is used to skip spread[0] if we're not showing front endleaf
        nextSpread = nextSection
          .get('spreads')
          .get(showFrontEndleafMagicNumber)
          .toJS();
        destinationSectionID = nextSection.get('sectionID');
      }
    } else {
      spreadToLoad = Math.min(
        currentSpreadIndex + 1,
        currentSection.spreads.length - 1,
      );
      nextSpread = currentSection.spreads[spreadToLoad];
    }
  } else if (action.type == PREVIOUS_REVIEW_SPREAD) {
    if (currentSpreadIndex - 1 < showFrontEndleafMagicNumber) {
      let previousSectionIndex = currentSectionIndex - 1;
      if (previousSectionIndex >= 0) {
        let previousSection = sections.toList().toArray()[previousSectionIndex];
        const previousSectionSpreads = previousSection.get('spreads');
        nextSpread = previousSectionSpreads
          .get(previousSectionSpreads.count() - 1)
          .toJS();
        destinationSectionID = previousSection.get('sectionID');
      }
    } else {
      spreadToLoad = Math.max(currentSpreadIndex - 1, 0);
      nextSpread = currentSection.spreads[spreadToLoad];
    }
  }
  let projectPK = {};
  const data = 'header,sections';
  if (nextSpread !== undefined) {
    projectPK['projectPK'] = projectMetadata.get('projectPK');
    let project = yield getProject(projectPK, data, null, null, nextSpread.id);
    yield put(setReviewProject(project));
  }
}

function* setupSagas() {
  yield takeLatest(LOAD_REVIEW_PROJECT, reviewProjectHandler);
  yield takeLatest(NEXT_REVIEW_SPREAD, reviewProjectNavigationHandler);
  yield takeLatest(PREVIOUS_REVIEW_SPREAD, reviewProjectNavigationHandler);
}

/** ***********************************************************************
 *  Main Export
 *  *********************************************************************** */
export default {
  reducer: reducer,
  saga: setupSagas,
};
